export const TYPES = "types";
export const SAVE_ACTIVITY = "save_activity";
export const MARK_ATTENDANCE = "mark_attendance";
export const PENDING_ACTIVITY = "pending_activity";
export const IS_CHECKOUT = "is_checkout";
export const SAVE_TOLL = "save_toll";
export const TOLL_LIST = "toll_list";
export const TOLL_VIEW = "toll_view";
export const TOLL_FILTER = "toll_filter";
export const APPROVAL_PENDING_LIST = "approval_pending_list";
export const APPROVAL_ACTIVITY = "approval_activity";
export const FSE = "fse";
export const AM = "am";
export const AM_TOLL = "am_toll";
export const AM_TOLL_MONTHLY_PLAN = "am_toll_monthly_plan";
export const PJP_REVIEW = "pjp_review";
export const PJP_PENDING_LIST = "pjp_pending_list";
export const PJP_PENDING_APPROVE = "pjp_pending_approve";
export const FSE_OTP_GENERATE = "fse_otp_generate";
export const SAVE_FSE = "save_fse";
export const FSEs_DETAILS_BY_PJP_ID = "fse_details_by_pjp_id";
export const PJP_DETAILS_BY_ID = "pjp_details_by_id";
export const INACTIVE_FSE = "inactive_fse";
export const FSE_ACTIVATION_CHECK = "fse_activation_check";
export const FSE_INVENTORY = "fse_inventory";
export const FSE_TAG_TRANSFER = "fse_tag_transfer";
export const CALL_LOGS = "call_logs";
export const TOLL_PENDING_MEETING = "toll_pending_meeting";
export const NEAREST_PLAZA_FROM_OPERATOR = "nearest_plaza_from_operator";
export const SBI_ISSUANCE = "SBI_ISSUANCE";